import {
  DELETE_TASK,
  DELETE_TASK_SUCCESS,
  LOAD_TASK_BY_ID,
  LOAD_TASK_BY_ID_SUCCESS,
  LOAD_TASK_LABELS,
  LOAD_TASK_LABELS_SUCCESS,
  LOAD_TASK_STATUSES,
  LOAD_TASK_STATUSES_SUCCESS,
  LOAD_TASKS,
  LOAD_TASKS_SUCCESS,
  LOAD_TASKS_MIGRATE_SUCCESS,
  LOAD_TASKS_COMMENT_MIGRATE_SUCCESS,
  LOAD_TASK_MIGRATE_INFO,
  LOAD_TASK_MIGRATE_INFO_SUCCESS,
  UPDATE_TASK,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_IN_REPORT_SUCCESS,
  LOAD_TASKS_TREE_SUCCESS,
  DESTROY_TASKS_TREE,
  // Task label groups
  LOAD_TASK_LABEL_GROUPS,
  LOAD_TASK_LABEL_GROUPS_SUCCESS,
  // Task status groups
  LOAD_WORKFLOWS,
  LOAD_WORKFLOWS_SUCCESS,
  UPDATE_TASK_LABEL,
  UPDATE_TASK_LABEL_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_LABEL_GROUP,
  UPDATE_TASK_LABEL_GROUP_SUCCESS,
  UPDATE_WORKFLOW,
  UPDATE_WORKFLOW_SUCCESS,
  DELETE_TASK_LABEL,
  DELETE_TASK_LABEL_SUCCESS,
  DELETE_TASK_STATUS,
  DELETE_TASK_LABEL_GROUP,
  DELETE_TASK_LABEL_GROUP_SUCCESS,
  DELETE_TASK_STATUS_SUCCESS,
  TASK_SEND_EMOJI,
  TASK_SEND_EMOJI_SUCCESS,
  TASK_VIEW_COMMENT_NOTIFICATIONS,
  TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS,
  TASK_MIGRATE,
  UPDATE_TASKS,
  UPDATE_TASKS_SUCCESS,
  CLEAR_TASK_LABELS,
  CLEAR_TASK_STATUSES,
  // Task template actions
  LOAD_TASK_TEMPLATE_CONSTANTS,
  APPLY_TASK_TEMPLATE,
  LOAD_TASK_TEMPLATES,
  LOAD_TASK_TEMPLATES_SUCCESS,
  LOAD_TASK_TEMPLATE,
  LOAD_TASK_TEMPLATE_SUCCESS,
  UPDATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE_SUCCESS,
  DELETE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE_SUCCESS,
  // Task schedule actions
  LOAD_TASK_SCHEDULE,
  LOAD_TASK_SCHEDULE_SUCCESS,
  UPDATE_TASK_SCHEDULE,
  UPDATE_TASK_SCHEDULE_SUCCESS,
  DELETE_TASK_SCHEDULE,
  DELETE_TASK_SCHEDULE_SUCCESS,
  SUBSCRIBE_TASK_CHANGES,
  UNSUBSCRIBE_TASK_CHANGES,
  DELETE_WORKFLOW,
  DELETE_WORKFLOW_SUCCESS,
  CHANGE_STATUS_POSITION,
  CHANGE_STATUS_POSITION_SUCCESS,
  LOAD_TASK_STATUSES_COUNTERS,
  LOAD_TASK_STATUSES_COUNTERS_SUCCESS,
  UPDATE_TASK_ORDER,
  UPDATE_TASK_ORDER_SUCCESS,
} from 'constants/ActionTypes';

import { getIntlMessage } from 'helpers/utilHelpers';
import { getTaskUrl } from 'helpers/taskHelpers';

import { toggleTaskLabelForm, toggleTaskMigrateForm, toggleTaskScheduleForm } from 'actions/ui/formActions';
import { getSearch } from 'selectors/settingsSelectors';

// Default load task action.
export const loadTasks = (payload = {}) => {
  return {
    type: LOAD_TASKS,
    payload: {
      resource: 'tasks',
      onSuccess: loadTaskSuccess,
      ...payload,
    },
  };
};

// Action for load tasks tree by paginations
export const loadTasksTreeSuccess = (tasks, action) => {
  return {
    type: LOAD_TASKS_TREE_SUCCESS,
    tasks,
    action,
  };
};

// Action for destoing tasks tree
export const destroyTasksTree = () => {
  return {
    type: DESTROY_TASKS_TREE,
  };
};

// Load all tasks of the current user
export const loadUserTasks = (payload) => {
  return {
    type: LOAD_TASKS,
    payload: {
      resource: 'tasks',
      extraFields: ['privacyUsers'],
      onSuccess: (response) => loadTaskSuccess(response, true),
      onErrorMessage: getIntlMessage('task.load.error'),
      filters: {
        userTasks: {
          value: true,
        },
        notArchived: {
          value: true,
        },
      },
      onLoading: payload.onLoading,
    },
  };
};

// Begin loading of the task by id
export const loadTaskById = (taskId, payload = {}) => {
  return {
    type: LOAD_TASK_BY_ID,
    payload: {
      extraFields: ['spectators', 'parent', 'checklist', 'schedule'],
      resource: 'tasks/' + taskId,
      onSuccess: loadTaskByIdSuccess,
      onErrorMessage: getIntlMessage('task.loadById.error'),
      ...payload,
    },
  };
};

// Update task by id if loading is succeed
export const loadTaskByIdSuccess = (task) => {
  return {
    type: LOAD_TASK_BY_ID_SUCCESS,
    task,
  };
};

// Update tasks if loading is succeed
export const loadTaskSuccess = (tasks, saveIds = false) => {
  return {
    type: LOAD_TASKS_SUCCESS,
    tasks,
    saveIds,
  };
};

// Success action after load tasks in migrate form.
export const loadTasksMigrateSuccess = (tasks) => {
  return {
    type: LOAD_TASKS_MIGRATE_SUCCESS,
    tasks,
  };
};

// Success action after load tasks in comment migrate form.
export const loadTasksCommentMigrateSuccess = (
  tasks,
  {
    payload: {
      filters: {
        parentId: { value },
      },
    },
  },
) => {
  return {
    type: LOAD_TASKS_COMMENT_MIGRATE_SUCCESS,
    tasks,
    parentId: value,
  };
};

// Begin loading of the task labels
export const loadTaskLabels = () => {
  return {
    type: LOAD_TASK_LABELS,
    payload: {
      resource: 'task-labels',
      onSuccess: loadTaskLabelsSuccess,
      onErrorMessage: getIntlMessage('fetch.task.label.error'),
    },
  };
};

// Update task labels if loading is succeed
export const loadTaskLabelsSuccess = (labels) => {
  return {
    type: LOAD_TASK_LABELS_SUCCESS,
    labels,
  };
};

export const clearTaskLabels = () => {
  return {
    type: CLEAR_TASK_LABELS,
  };
};

// Begin loading of the task statuses
export const loadTaskStatuses = (payload = {}) => {
  return {
    type: LOAD_TASK_STATUSES,
    payload: {
      resource: 'task-statuses',
      onSuccess: loadTaskStatusesSuccess,
      onErrorMessage: getIntlMessage('fetch.task.status.error'),
      fields: payload?.fields ?? [
        'alias',
        'color',
        'companyId',
        'name',
        'position',
        'status',
        'statusId',
        'timeCreated',
        'timeUpdated',
        'workflowId',
      ],
      ...payload,
    },
  };
};

// Update task statuses if loading is succeed
export const loadTaskStatusesSuccess = (statuses) => {
  return {
    type: LOAD_TASK_STATUSES_SUCCESS,
    statuses,
  };
};

export const clearTaskStatuses = () => {
  return {
    type: CLEAR_TASK_STATUSES,
  };
};

// Task update request
export const updateTask = (values, payload = {}, history = null) => {
  return {
    type: UPDATE_TASK,
    payload: {
      extraFields: ['spectators', 'checklist', 'isInFiltration'],
      resource: 'tasks',
      onSuccess: updateTaskSuccess,
      entityPrimaryKey: 'taskId',
      ...payload,
      // Перекрываем onSuccessFunction, который в payload
      onSuccessFunction: (response) => {
        if (payload.onSuccessFunction) {
          payload.onSuccessFunction(response);
        }
        if (history) {
          history.push(getTaskUrl(response));
        }
      },
    },
    values,
  };
};

// Request to update some task fields
export const updateSomeTaskFields = (values, afterSuccess, onSuccess = null, payload = {}) => {
  return {
    type: UPDATE_TASK,
    payload: {
      extraFields: ['spectators', 'labels', 'taskStatus', 'isInFiltration'],
      resource: 'tasks',
      onSuccess: onSuccess ? onSuccess : updateTaskSuccess,
      entityPrimaryKey: 'taskId',
      afterSuccess: afterSuccess,
      ...payload,
    },
    values,
  };
};

export const updateTaskInReportSuccess = (value) => {
  return {
    type: UPDATE_TASK_IN_REPORT_SUCCESS,
    value,
  };
};

export const updateTaskOrder = (values, payload) => {
  return {
    type: UPDATE_TASK_ORDER,
    payload: {
      resource: `tasks/${values.taskId}/order`,
      method: 'PUT',
      onSuccess: updateTaskOrderSuccess,
      ...payload,
    },
    values,
  };
};

export const updateTaskOrderSuccess = (_, { values }) => {
  return {
    type: UPDATE_TASK_ORDER_SUCCESS,
    values,
  };
};

// Task update success
export const updateTaskSuccess = (task, { values }) => {
  return {
    type: UPDATE_TASK_SUCCESS,
    task,
    values,
  };
};

export const batchUpdateTasks = (values, payload = {}) => {
  return {
    type: UPDATE_TASKS,
    payload: {
      resource: 'tasks/batch',
      extraFields: ['spectators'],
      onSuccess: batchUpdateTasksSuccess,
      ...payload,
    },
    values,
  };
};

export const batchUpdateTasksSuccess = (tasks, action) => {
  return {
    type: UPDATE_TASKS_SUCCESS,
    tasks,
    isDelete: action.values?.action === 'delete',
  };
};

// Sending a request to the server to delete task
export const deleteTask = (taskId, payload = {}) => {
  return {
    type: DELETE_TASK,
    payload: {
      resource: 'tasks',
      entityId: taskId,
      onSuccess: deleteTaskSuccess,
      onErrorMessage: getIntlMessage('task.delete.error'),
      ...payload,
    },
  };
};

// Delete task if sending succeed
export const deleteTaskSuccess = (taskId, payload = {}) => {
  return {
    type: DELETE_TASK_SUCCESS,
    taskId,
    projectId: payload.projectId,
  };
};

// Send request for subscribe task
export const subscribeOnTask = (payload = {}) => {
  return {
    type: UPDATE_TASK,
    payload: {
      extraFields: ['spectators'],
      resource: `tasks/${payload.values.taskId}/subscribe`,
      onSuccess: updateTaskSuccess,
      method: 'PUT',
      ...payload,
    },
    values: payload.values,
  };
};

// Send request for update task meta
export const updateTaskMeta = (payload = {}) => {
  return {
    type: UPDATE_TASK,
    payload: {
      extraFields: ['spectators', 'isInFiltration'],
      resource: `tasks/${payload.values.taskId}/meta`,
      onSuccess: updateTaskSuccess,
      method: 'PUT',
      ...payload,
    },
    values: payload.values,
  };
};

export const loadTaskLabelGroups = (payload) => {
  return {
    type: LOAD_TASK_LABEL_GROUPS,
    payload: {
      resource: 'task-label-groups',
      extraFields: ['taskCount'],
      onSuccess: loadTaskLabelGroupsSuccess,
      onErrorMessage: getIntlMessage('labelGroup.load.error'),
      ...payload,
    },
  };
};

const loadTaskLabelGroupsSuccess = (values) => {
  return {
    type: LOAD_TASK_LABEL_GROUPS_SUCCESS,
    values,
  };
};

export const loadWorkflows = (payload) => {
  return {
    type: LOAD_WORKFLOWS,
    payload: {
      resource: 'task-workflows',
      extraFields: ['taskCount'],
      onSuccess: loadWorkflowsSuccess,
      onErrorMessage: getIntlMessage('workflow.load.error'),
      ...payload,
    },
  };
};

const loadWorkflowsSuccess = (values) => {
  return {
    type: LOAD_WORKFLOWS_SUCCESS,
    values,
  };
};

// Action for send request on update task label
export const updateTaskLabel = (values, resolve, reject) => {
  return {
    type: UPDATE_TASK_LABEL,
    promise: { resolve, reject },
    payload: {
      resource: 'task-labels',
      extraFields: [],
      onSuccess: updateTaskLabelSuccess,
      afterSuccess: toggleTaskLabelForm,
      entityPrimaryKey: 'labelId',
    },
    values,
  };
};

const updateTaskLabelSuccess = (values) => {
  return {
    type: UPDATE_TASK_LABEL_SUCCESS,
    values,
  };
};

// Action for send request on update task status
export const updateTaskStatus = (values, resolve, reject) => {
  return {
    type: UPDATE_TASK_STATUS,
    promise: { resolve, reject },
    payload: {
      resource: 'task-statuses',
      extraFields: [],
      onSuccess: updateTaskStatusSuccess,
      afterSuccess: toggleTaskLabelForm,
      entityPrimaryKey: 'statusId',
    },
    values,
  };
};

const updateTaskStatusSuccess = (values) => {
  return {
    type: UPDATE_TASK_STATUS_SUCCESS,
    values,
  };
};

// Action for send request on update task label group
export const updateTaskLabelGroup = (values, resolve, reject) => {
  return {
    type: UPDATE_TASK_LABEL_GROUP,
    promise: { resolve, reject },
    payload: {
      resource: 'task-label-groups',
      extraFields: ['taskCount'],
      onSuccess: updateTaskLabelGroupSuccess,
      entityPrimaryKey: 'labelGroupId',
    },
    values,
  };
};

const updateTaskLabelGroupSuccess = (values) => {
  return {
    type: UPDATE_TASK_LABEL_GROUP_SUCCESS,
    values,
  };
};

// Action for send request on update task status group
export const updateWorkflow = (values, resolve, reject) => {
  return {
    type: UPDATE_WORKFLOW,
    promise: { resolve, reject },
    payload: {
      resource: 'task-workflows',
      extraFields: ['taskCount'],
      onSuccess: updateWorkflowSuccess,
      entityPrimaryKey: 'workflowId',
    },
    values,
  };
};

const updateWorkflowSuccess = (values) => {
  return {
    type: UPDATE_WORKFLOW_SUCCESS,
    values,
  };
};

// Action for send request on delete task label
export const deleteTaskLabel = (labelId) => {
  return {
    type: DELETE_TASK_LABEL,
    payload: {
      resource: 'task-labels',
      entityId: labelId,
      onSuccess: deleteTaskLabelSuccess,
      onErrorMessage: getIntlMessage('label.delete.error'),
    },
  };
};

const deleteTaskLabelSuccess = (labelId) => {
  return {
    type: DELETE_TASK_LABEL_SUCCESS,
    labelId,
  };
};

// Action for send request on delete task status
export const deleteTaskStatus = (statusId, companyId) => {
  return {
    type: DELETE_TASK_STATUS,
    payload: {
      props: { companyId },
      resource: 'task-statuses',
      entityId: statusId,
      onSuccess: deleteTaskStatusSuccess,
      onErrorMessage: getIntlMessage('status.delete.error'),
    },
  };
};

const deleteTaskStatusSuccess = (statusId, props) => {
  return {
    type: DELETE_TASK_STATUS_SUCCESS,
    statusId,
    companyId: props?.companyId,
  };
};

// Action for send request on delete task label group
export const deleteTaskLabelGroup = (labelGroupId) => {
  return {
    type: DELETE_TASK_LABEL_GROUP,
    payload: {
      resource: 'task-label-groups',
      entityId: labelGroupId,
      onSuccess: deleteTaskLabelGroupSuccess,
      onErrorMessage: getIntlMessage('labelGroup.delete.error'),
    },
  };
};

const deleteTaskLabelGroupSuccess = (labelGroupId) => {
  return {
    type: DELETE_TASK_LABEL_GROUP_SUCCESS,
    labelGroupId,
  };
};

// Action for send request on delete task status group
export const deleteWorkflow = (workflowId, payload) => {
  return {
    type: DELETE_WORKFLOW,
    payload: {
      resource: 'task-workflows',
      entityId: workflowId,
      onSuccess: deleteWorkflowSuccess,
      onErrorMessage: getIntlMessage('workflow.delete.error'),
      ...payload,
    },
  };
};

const deleteWorkflowSuccess = (workflowId) => {
  return {
    type: DELETE_WORKFLOW_SUCCESS,
    workflowId,
  };
};

// Sending a request to the server to add reactions
export const taskSendEmoji = (entityId, values) => {
  return {
    type: TASK_SEND_EMOJI,
    payload: {
      resource: 'tasks/' + entityId + '/react',
      taskId: entityId,
      onSuccess: taskSendEmojiSuccess,
      onErrorMessage: getIntlMessage('comment.emoji.error'),
    },
    values,
  };
};

export const taskSendEmojiSuccess = (values) => {
  return {
    type: TASK_SEND_EMOJI_SUCCESS,
    values,
  };
};

export const taskViewCommentNotificationsAction = (taskId) => {
  return {
    type: TASK_VIEW_COMMENT_NOTIFICATIONS,
    payload: {
      resource: 'feed/task',
      entityPrimaryKey: 'taskId',
      onSuccess: (values) => taskViewCommentNotificationsActionSuccess(values, taskId),
    },
    values: { taskId },
  };
};

export const taskViewCommentNotificationsActionSuccess = (values, taskId) => {
  return {
    type: TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS,
    values,
    taskId,
  };
};

// Load info for migrate task to other project
export const loadTaskMigrateInfo = (payload = {}) => {
  return {
    type: LOAD_TASK_MIGRATE_INFO,
    payload: {
      resource: 'tasks/' + payload.taskId + '/migrate-info',
      onSuccess: loadTaskMigrateInfoSuccess,
      queryParams: {
        projectId: payload.projectId,
      },
      ...payload,
    },
  };
};
const loadTaskMigrateInfoSuccess = (response) => {
  return {
    type: LOAD_TASK_MIGRATE_INFO_SUCCESS,
    response,
  };
};

// Send request for migrate task and sub tasks
export const taskMigrate = (payload = {}) => {
  return {
    type: TASK_MIGRATE,
    payload: {
      resource: 'tasks/' + payload.values.taskId + '/migrate',
      extraFields: ['spectators'],
      onSuccess: loadTaskByIdSuccess,
      afterSuccess: () => toggleTaskMigrateForm(),
      onErrorMessage: getIntlMessage('task.migrate.error'),
      onSuccessMessage: getIntlMessage('request.success'),
      ...payload,
    },
    values: payload.values,
  };
};

// Task template actions
// ---------------------

/**
 * Action for load task template constants (ListAction)
 * @param payload
 * @returns {{payload: {resource: string}, type: string}}
 */
export const loadTaskTemplateConstants = (payload = {}) => {
  return {
    type: LOAD_TASK_TEMPLATE_CONSTANTS,
    payload: {
      resource: 'task-templates/list',
      ...payload,
    },
  };
};

/**
 * Action for load task templates (IndexAction)
 * @param payload
 * @returns {{payload: {resource: string, onSuccess: (function(*): {values: *, type: string})}, type: string}}
 */
export const loadTaskTemplates = (payload = {}) => {
  return {
    type: LOAD_TASK_TEMPLATES,
    payload: {
      resource: 'task-templates',
      onSuccess: loadTaskTemplatesSuccess,
      filters: {
        search: {
          selector: getSearch,
        },
      },
      ...payload,
    },
  };
};
const loadTaskTemplatesSuccess = (values) => {
  return {
    type: LOAD_TASK_TEMPLATES_SUCCESS,
    values,
  };
};

/**
 * Action for load task template by id
 * @param templateId
 * @param payload
 * @returns {{payload: {resource: string, onSuccess: (function(*): {type: string, value: *})}, type: string}}
 */
export const loadTaskTemplateById = (templateId, payload = {}) => {
  return {
    type: LOAD_TASK_TEMPLATE,
    payload: {
      resource: 'task-templates/' + templateId,
      onSuccess: loadTaskTemplateByIdSuccess,
      ...payload,
    },
  };
};
const loadTaskTemplateByIdSuccess = (value) => {
  return {
    type: LOAD_TASK_TEMPLATE_SUCCESS,
    value,
  };
};

/**
 * Action for update/create task template (CreateAction, UpdateAction)
 * @param values
 * @param payload
 * @returns {{payload: {resource: string, entityPrimaryKey: string, onSuccess: (function(*): {type: string, value: *})}, values: *, type: string}}
 */
export const updateTaskTemplate = (values, payload = {}) => {
  return {
    type: UPDATE_TASK_TEMPLATE,
    payload: {
      resource: 'task-templates',
      entityPrimaryKey: 'templateId',
      onSuccess: updateTaskTemplateSuccess,
      ...payload,
    },
    values,
  };
};
const updateTaskTemplateSuccess = (value) => {
  return {
    type: UPDATE_TASK_TEMPLATE_SUCCESS,
    value,
  };
};

/**
 * Action for delete task template (DeleteAction)
 * @param entityId
 * @param payload
 * @returns {{payload: {resource: string, entityId: *, onSuccess: (function(*): {entityId: *, type: string})}, type: string}}
 */
export const deleteTaskTemplate = (entityId, payload = {}) => {
  return {
    type: DELETE_TASK_TEMPLATE,
    payload: {
      resource: 'task-templates',
      onSuccess: deleteTaskTemplateSuccess,
      entityId,
      ...payload,
    },
  };
};
const deleteTaskTemplateSuccess = (entityId) => {
  return {
    type: DELETE_TASK_TEMPLATE_SUCCESS,
    entityId,
  };
};

/**
 * Action send request for get values by template in task
 * @param templateId
 * @param projectId
 * @param payload
 * @returns {{payload: {resource: string, queryParams: {templateId: *, projectId: *}}, type: string}}
 */
export const applyTaskTemplateAction = (templateId, projectId, payload = {}) => {
  return {
    type: APPLY_TASK_TEMPLATE,
    payload: {
      resource: 'task-templates/apply',
      queryParams: { templateId, projectId },
      ...payload,
    },
  };
};

// TaskSchedule load request
export const loadTaskSchedule = (payload = {}) => {
  return {
    type: LOAD_TASK_SCHEDULE,
    payload: {
      resource: 'schedules',
      extraFields: ['title', 'projectName'],
      onSuccess: loadTaskScheduleSuccess,
      filters: {
        entity: { value: 'task' },
      },
      ...payload,
    },
  };
};

const loadTaskScheduleSuccess = (schedules) => {
  return {
    type: LOAD_TASK_SCHEDULE_SUCCESS,
    schedules,
  };
};

// TaskSchedule update request
export const updateTaskSchedule = (values, payload = {}) => {
  return {
    type: UPDATE_TASK_SCHEDULE,
    payload: {
      resource: 'schedules',
      extraFields: ['title', 'projectName'],
      onSuccess: (schedule) => updateTaskScheduleSuccess(values.entityId, schedule),
      afterSuccess: toggleTaskScheduleForm,
      entityPrimaryKey: 'scheduleId',
      ...payload,
    },
    values,
  };
};

const updateTaskScheduleSuccess = (taskId, schedule) => {
  return {
    type: UPDATE_TASK_SCHEDULE_SUCCESS,
    taskId,
    schedule,
  };
};

// TaskSchedule delete request
export const deleteTaskSchedule = (entityId, payload = {}) => {
  return {
    type: DELETE_TASK_SCHEDULE,
    payload: {
      resource: 'schedules',
      onSuccess: deleteTaskScheduleSuccess,
      entityId,
      ...payload,
    },
  };
};
const deleteTaskScheduleSuccess = (entityId) => {
  return {
    type: DELETE_TASK_SCHEDULE_SUCCESS,
    entityId,
  };
};

export const subscribeActivityLogChanges = () => {
  return {
    type: SUBSCRIBE_TASK_CHANGES,
  };
};

export const unsubscribeActivityLogChanges = () => {
  return {
    type: UNSUBSCRIBE_TASK_CHANGES,
  };
};

export const loadTaskStatusesCounters = (payload) => ({
  type: LOAD_TASK_STATUSES_COUNTERS,
  payload: {
    resource: 'task-statuses',
    onErrorMessage: getIntlMessage('fetch.task.status.error'),
    onSuccess: loadTaskStatusesCountersSuccess,
    fields: ['statusId', 'taskCount'],
    ...payload,
  },
});

export const loadTaskStatusesCountersSuccess = (values) => ({
  type: LOAD_TASK_STATUSES_COUNTERS_SUCCESS,
  values,
});

export const changeStatusPosition = (values, payload) => ({
  type: CHANGE_STATUS_POSITION,
  payload: {
    method: 'PUT',
    resource: `task-statuses/${values.statusId}/change-position`,
    onSuccess: changeStatusPositionSuccess,
    ...payload,
  },
  values,
});

const changeStatusPositionSuccess = (payload) => ({
  type: CHANGE_STATUS_POSITION_SUCCESS,
  payload,
});
